import styled from "styled-components";

export const BackButton = styled.div`
  cursor: pointer;
  justify-content: center;
  align-items: center;
  display: flex;
`;
